import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useLocation, useNavigate } from 'react-router-dom';
import { useMutation, useQuery } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
// import useMediaQuery from '@mui/material/useMediaQuery';

import { fetch_one } from "../../../lib/v31lib";
import { loginAtom } from '../../../lib/auth';

import Lenis from "lenis";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { gsap } from "gsap";

import {
  Box,
  Grid,
} from '@mui/material';

import {
  Footer,
  WhiteSection
} from '../../../components/v2/custom';
import {
  DarkGreenButton,
  Page,
  Stepper,
  TextButton,
  Typography
} from '../../../components/v2/styled';
import { MeetingVoteSlideProfile } from './slides/Profile';
import { MeetingVoteSlideNormal } from './slides/Normal';

import { Meeting } from '../../../models/Meeting';
import { User } from '../../../models/User';

const { DateTime } = require("luxon");

type Props = {}

export const MeetingVote: FunctionComponent<Props> = ({}) => {
  const [login, setLogin] = useAtom(loginAtom);
  const theme = useTheme();
  const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);
  const { state } = useLocation();

  const lenis = new Lenis({
    // duration: 2,
  });

  const [meeting, setMeeting] = useState<Meeting>(state?.meeting);
  const [user, setUser] = useState<User>(state?.user);
  const avStuffHere = !!user?.av_stuff?.meeting_id
    ? (user.av_stuff.meeting_id === meeting?.id ? user.av_stuff : undefined)
    : (state?.av_meeting_id === meeting?.id ? user.av_stuff : undefined);
  const hasVotedHere = meeting?.vote_status === 'already_voted' || avStuffHere?.type === 'vote';
  const [showError, setShowError] = useState<boolean>(false);
  const [showSuccess, setShowSuccess] = useState<boolean>(false);
  const [error, setError] = useState<string>();
  const [step, setStep] = useState<number>(0);
  const [answers, setAnswers] = useState<number[]>([]);









  const mutationCustomAction = useMutation({
    mutationFn: (pars: {
      formData: any;
      step: number;
    }) => {
      return fetch_one<{
        custom_result: any
      }>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/pub/custom_action`,
        pars.formData,
        undefined
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      //@ts-ignore
      setError(data.data);
      setShowError(true);
      return true;
    },
    onSuccess: (data, variables, context) => {
      console.log(data);

      setShowError(false);
      setError(undefined);

      if (variables.step === 0) { // verification
        if (!!data.custom_result.vennoot_number) {
          setUser({
            ...data.custom_result,
            birth_date: DateTime.fromISO(data.custom_result?.birth_date).toFormat("dd/LL/y")
          });
          setStep(1);
          setTimeout(() => {
            // lenis.scrollTo("top");
            window.scrollTo(0, 0);
          }, 200);
        } else {
          setError(data.custom_result);
          setShowError(true);
        }
      }
      if (variables.step === 100) { // verification
        if (!!data.custom_result.vennoot_number) {
          navigate(`/av?id=${meeting?.id || ''}`, {state: {
            av_meeting_id: meeting?.id,
            user: {
              ...user,
              ...data.custom_result,
              id: user?.id || data.custom_result.id,
              birth_date: DateTime.fromISO(data.custom_result?.birth_date).toFormat("dd/LL/y")
            }
          }});
        } else {
          setError(data.custom_result);
          setShowError(true);
        }
      }

      if (!!data.custom_result.user) {
        setUser({
          ...data.custom_result.user,
          birth_date: DateTime.fromISO(data.custom_result.user?.birth_date).toFormat("dd/LL/y")
        });
      }
    },
  });








  
  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    lenis.on("scroll", ScrollTrigger.update);

    gsap.ticker.add((time) => {
      lenis.raf(time * 1000);
    });

    gsap.ticker.lagSmoothing(0);
  }, []);
  useEffect(() => {
    if (!!state?.user) setUser(state?.user);
    if (!!state?.meeting) setMeeting(state?.meeting);
  }, [state?.user, state?.meeting]);
  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(() => {
      window.scrollTo(0, 0);
      lenis.scrollTo("top");
    }, 200);
  }, [step]);
  useEffect(() => {
    if ((meeting?.voting_data || []).length > 0 && answers.length < 1) setAnswers(new Array((state?.meeting?.voting_data || []).length).fill(999));
  }, [meeting]);

  return <Page sx={{paddingTop: '100px', backgroundColor: theme.palette.background.default}}>
    
    <WhiteSection isTransparent sx={{
      "& > div > div": {
        padding: 0
      },
      "& > div > div > div > div": {
        minHeight: 600,
        height:'auto'
      }
    }}>
      <Grid container spacing={1} sx={{
        width: {
          xs: '100%',
          lg: '900px'
        },
        marginLeft: 'auto',
        marginRight: 'auto',
        marginBottom: 4
      }}>
        {!!user && !!meeting && <Grid item xs={12} sx={{textAlign: 'center', marginBottom: 8}}>
          <Stepper activeStep={step > 10 ? (step - 10) : step} steps={2 + (meeting?.voting_data || []).length} />
        </Grid>}
        {step === 0 && <Grid item xs={12} sx={{textAlign: 'center'}}>
          <Typography variant="h1" sx={{display: 'inline-block',}}>{t("nw.meetings.notification.cta.online_voting")}</Typography>
        </Grid>}
        {(!user || !meeting) && <Grid item xs={12} sx={{textAlign: 'center'}}>
          <Typography variant="body1" sx={{display: 'inline-block', color: theme.palette.warning.main}} html altLinks>{t("nw.meeting.error.reload_from_av")}</Typography>
        </Grid>}

    {/* let active = DateTime.fromISO(meeting?.last_day_vote).set({hour: 12, minute: 0, second: 0}) >= DateTime.now();
    let already_registered = (avStuffHere?.type === 'physical' && !!avStuffHere?.enabled);
    let already_voted = (avStuffHere?.type === 'vote');
    let gave_volmacht = (avStuffHere?.type === 'physical' && !!avStuffHere?.volmacht); */}


        {!!user && !!meeting && <>
          {!!showError && <Grid item xs={12} sx={{textAlign: 'center'}}>
            <Typography sx={{color: theme.palette.warning.main}} variant="body1">{t(`nw.meetings.errors.${error}`).replace(/<[^>]*>?/gm, '')}</Typography>
          </Grid>}
          {!showError && <>
            {!(DateTime.fromISO(meeting?.last_day_vote).set({hour: 12, minute: 0, second: 0}) > DateTime.now()) && <Grid item xs={12} sx={{textAlign: 'center'}}>
              <Typography sx={{color: theme.palette.warning.main}} variant="body1">{t("nw.meetings.notification.error.after_physical_last_day").replace(/<[^>]*>?/gm, '')}</Typography>
            </Grid>}
            {!!(DateTime.fromISO(meeting?.last_day_vote).set({hour: 12, minute: 0, second: 0}) > DateTime.now()) && <>
              {!!(hasVotedHere) && <Grid item xs={12} sx={{textAlign: 'center'}}>
                <Typography sx={{color: theme.palette.warning.main}} variant="body1">{t("nw.meetings.physical.attendance.already_voted").replace(/<[^>]*>?/gm, '')}</Typography>
              </Grid>}
              {!(hasVotedHere) && <>
                {!!(avStuffHere?.type === 'physical' && !!avStuffHere?.volmacht) && <Grid item xs={12} sx={{textAlign: 'center'}}>
                  <Typography variant='body1'>{t("nw.meetings.physical.attendance.gave_volmacht").replace(/<[^>]*>?/gm, '')}</Typography>
                </Grid>}
                {!(avStuffHere?.type === 'physical' && !!avStuffHere?.volmacht) && <>
                  {!!(avStuffHere?.type === 'physical' && !!avStuffHere?.enabled) && <Grid item xs={12} sx={{textAlign: 'center'}}>
                    <Typography variant='body1'>{t("nw.meetings.physical.attendance.already_registered").replace(/<[^>]*>?/gm, '')}</Typography>
                  </Grid>}
                  {!(avStuffHere?.type === 'physical' && !!avStuffHere?.enabled) && <>
                    {/* first step */}
                    {step === 0 && <Grid xs={12}>
                      <Typography variant='body1' html altLinks sx={{display: 'block'}}>{meeting?.field_voting_intro}</Typography>
                      <Typography variant='body1' html altLinks sx={{display: 'block'}}>{meeting?.field_voting_documents}</Typography>
                    </Grid>}
                    {/* last step */}
                    {step === (1 + (meeting?.voting_data || []).length) && <Grid xs={12}>
                      {answers.filter(i => i === 999).length < 1 && <Typography variant='body1' html altLinks sx={{display: 'block'}}>{t("meeting.online.outro")}</Typography>}
                      {answers.filter(i => i === 999).length > 0 && <Typography variant='body1' html altLinks sx={{display: 'block'}}>{t("meeting.online.outro_warning")}</Typography>}
                    </Grid>}
                    {/* questions */}
                    {(meeting?.voting_data || []).map((question, i) => <>
                      {question.type === 'profile' && <MeetingVoteSlideProfile
                        question={question}
                        hidden={(step - 1) !== i}
                      />}
                      {question.type !== 'profile' && <MeetingVoteSlideNormal
                        question={question}
                        is_help_visible={meeting?.is_help_visible}
                        hidden={(step - 1) !== i}
                        value={answers[i]}
                        onChange={(num) => {
                          let answ: number[] = [...answers];
                          answ[i] = num;
                          setAnswers(answ);
                        }}
                      />}
                    </>)}

                    <Grid xs={12} sx={{display: 'flex', justifyContent: 'center', marginTop: 2}}>
                      {step !== 0 && !mutationCustomAction.isPending && <TextButton
                        label={t("nw.meeting.online.btn.back").replace(/<[^>]*>?/gm, '')}
                        id="back_btn_steps"
                        onClick={(e) => {
                          setStep(step - 1);
                        }}
                        sx={{
                          margin: 1,
                          "&:hover": {
                            borderColor: theme.palette.primary.dark,
                            backgroundColor: theme.palette.primary.light,
                            color: theme.palette.primary.dark,
                          },
                          "&.Mui-disabled": {
                            color: 'grey',
                          },
                        }}
                      />}
                      {/* disabled als vraag leeg is */}
                      {step !== (2 + (meeting?.voting_data || []).length) - 2 && step !== (2 + (meeting?.voting_data || []).length) - 1 && <DarkGreenButton
                        disabled={step > 0 && answers[step - 1] !== 0 && answers[step - 1] !== 1 && answers[step - 1] !== 2}
                        label={t("nw.meeting.online.btn.next").replace(/<[^>]*>?/gm, '')}
                        id="next_btn_steps"
                        onClick={(e) => {
                          setStep(step + 1);
                        }}
                        sx={{
                          margin: 1,
                          "&:hover": {
                            borderColor: theme.palette.primary.dark,
                            backgroundColor: theme.palette.primary.light,
                            color: theme.palette.primary.dark,
                          },
                          "&.Mui-disabled": {
                            color: 'grey',
                          },
                        }}
                      />}
                      {step === (2 + (meeting?.voting_data || []).length) - 2 && <DarkGreenButton
                        disabled={answers[step - 1] !== 0 && answers[step - 1] !== 1 && answers[step - 1] !== 2}
                        label={t("nw.meeting.online.btn.confirm").replace(/<[^>]*>?/gm, '')}
                        id="cnf_btn_steps"
                        onClick={(e) => {
                          setStep(step + 1);
                        }}
                        sx={{
                          margin: 1,
                          "&:hover": {
                            borderColor: theme.palette.primary.dark,
                            backgroundColor: theme.palette.primary.light,
                            color: theme.palette.primary.dark,
                          },
                          "&.Mui-disabled": {
                            color: 'grey',
                          },
                        }}
                      />}
                      {step === (2 + (meeting?.voting_data || []).length) - 1 && <DarkGreenButton
                        loading={mutationCustomAction.isPending}
                        label={t("nw.meeting.online.btn.confirm").replace(/<[^>]*>?/gm, '')}
                        id="confirm_btn_steps"
                        onClick={(e) => {
                          mutationCustomAction.mutate({
                            formData: {
                              object: 'meeting',
                              class_action: 'custom_api_cast_vote',
                              user_id: user?.id,
                              meeting_id: meeting?.id,
                              answers: answers
                            },
                            step: 100
                          })
                        }}
                        sx={{
                          margin: 1,
                          "&:hover": {
                            borderColor: theme.palette.primary.dark,
                            backgroundColor: theme.palette.primary.light,
                            color: theme.palette.primary.dark,
                          },
                          "&.Mui-disabled": {
                            color: 'grey',
                          },
                        }}
                      />}
                    </Grid>
                  </>}
                </>}
              </>}
            </>}
          </>}
        </>}

      </Grid>
    </WhiteSection>

    <Footer normalPage />
  </Page>;
}

